import Vue from 'vue'
import Router from 'vue-router'
import systemRoutes from './system.js'
const login = () => import('@/page/login')
const main = () => import('@/page/main')
const countManage = () => import('@/page/faces/count-manage')
const equipmentAdd = () => import('@/page/faces/equipment-add')
const staffAdd = () => import('@/page/faces/staff-add')
const portIn = () => import('@/page/faces/port-in')
const importBind = () => import('@/page/faces/import-bind')
const errorLog = () => import('@/page/faces/error-log')

const classManagement = () => import('../page/checkWork/class-management.vue')
const turnManagement = () => import('../page/checkWork/turn-management.vue')
const reportManagement = () => import('../page/checkWork/report-management.vue')
const attend = () => import('../page/checkWork/attend.vue')
const attendManagement = () => import('../page/checkWork/attend-management.vue')
const timeSlot = () => import('../page/checkWork/time-slot.vue')
const schedulingView = () => import('../page/checkWork/scheduling-view2.vue')
const addScheduling = () => import('../page/checkWork/add-scheduling.vue')
const menuManagement = () => import('../page/faces/menu-management.vue')
const holidaySettings = () => import('@/page/checkWork/holiday-settings.vue')
const approval = () => import('@/page/checkWork/approval.vue')
const approvalLeave = () => import('@/page/checkWork/approval-leave.vue')
const approvalTrip = () => import('@/page/checkWork/approval-trip.vue')
const approvalOvertime = () => import('@/page/checkWork/approval-overtime.vue')
const approvalForget = () => import('@/page/checkWork/approval-forget.vue')
//2.0
const recoRecords = () => import('@/page/system/reco-record.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/main',
      component: main,
      children: [
        {
          path: '/count-manage',
          component: countManage,
          name: 'count-manage'
        },
        {
          path: '/equipment-add',
          component: equipmentAdd,
          name: 'equipment-add'
        },
        {
          path: '/staff-add',
          component: staffAdd,
          name: 'staff-add'
        },
        {
          path: '/port-in',
          component: portIn,
          name: 'port-in'
        },
        {
          path: '/import-bind',
          component: importBind,
          name: 'import-bind'
        },
        {
          path: '/error-log',
          component: errorLog,
          name: 'error-log'
        },
        {
          path: '/class-management',
          component: classManagement,
          name: 'class-management'
        },
        {
          path: '/turn-management',
          component: turnManagement,
          name: 'turn-management'
        },
        {
          path: '/scheduling-view',
          component: schedulingView,
          name: 'SchedulingView',
        },
        {
          path: '/add-scheduling',
          component: addScheduling,
          name: 'addScheduling',
        },
        {
          path: '/attend',
          component: attend,
          name: 'attend',
          children: [
            {
              path: '/attend-management',
              component: attendManagement,
              name: 'attendManagement'
            },
            {
              path: '/report-management',
              component: reportManagement,
              name: 'reportManagement'
            }
          ]
        },
        {
          path: '/menu-management',
          component: menuManagement,
          name: 'menuManagement'
        },
        {
          path: '/holiday-management',
          component: holidaySettings,
          name: 'holidaySettings'
        },
        {
          path: '/timerange-management',
          component: timeSlot,
          name: 'timeSlot'
        },
        {
        	path: '/system/reco-record',
        	component: recoRecords,
        	name: 'recoRecords'
        },
        {
          path: '/check/approval',
          component: approval,
          name: 'approval',
          redirect: '/check/approval/leave',
          children: [
            {
              path: 'leave',
              component: approvalLeave,
              name: 'approvalLeave'
            },
            {
              path: 'trip',
              component: approvalTrip,
              name: 'approvalTrip'
            },
            {
              path: 'overtime',
              component: approvalOvertime,
              name: 'approvalOvertime'
            },
            {
              path: 'forget',
              component: approvalForget,
              name: 'approvalForget'
            }
          ]
        }
      ].concat(systemRoutes)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js